<template>
  <div class="weight-form">
    <div class="wrap">
      <input
          step=".1"
          type="number"
          v-model="newWeight.weight"
          placeholder="Jouw gewicht in kg..."
      />

      <input
          type="date"
          v-model="newWeight.date"
          placeholder="Datum"
      />

      <button @click="saveTask">
        Opslaan
      </button>
    </div>

    <span class="error" v-if="errorMessage">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "SetWeightForm",
  data() {
    return {
      errorMessage: "",
      newWeight: {
        weight: "",
        date: this.getTodayDate(), // default to today
      },
    };
  },
  methods: {
    ...mapActions("weight", ["setWeight"]),
    getTodayDate() {
      const today = new Date();
      return today.toISOString().substr(0, 10); // "YYYY-MM-DD"
    },
    saveTask(e) {
      e.preventDefault();
      this.errorMessage = "";

      if (this.newWeight.weight) {
        this.setWeight(this.newWeight).then(() => {
          this.newWeight.weight = "";
          this.newWeight.date = this.getTodayDate();

          this.$emit("created");
        });
      } else {
        this.errorMessage = "Vul jouw gewicht in";
      }
    },
  },
};
</script>
